import React, { FC, useRef, useState } from 'react';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import { downloadSettlement, SettlementDocument } from 'src/fetch/stepE/download';
import { errorModalViewStore } from 'src/store/modal';
import './style.scss';

interface Props {
  data: any;
}

const HomeTaxData: FC<Props> = ({ data }) => {
  const busy = useRef(false);
  const [downloading, setDownloading] = useState(false);
  const setErrorState = errorModalViewStore(state => state.set);
  const clickEvt = async (type: SettlementDocument) => {
    if (busy.current) return;
    busy.current = true;
    setDownloading(true);
    try {
      await downloadSettlement(type);
    } catch (error: any) {
      setErrorState({
        active: '_active',
        data: {
          type: 'error',
          icon: 'ri-alert-line',
          mainTitle: error.message || '파일 다운로드에 실패했습니다.',
          subTitle: '',
        },
      });
    } finally {
      busy.current = false;
      setDownloading(false);
    }
  };

  return (
    <div className="_step_e_outpayment_data">
      <div className="_content">
        <div className="_btn_div">
          <div className="_item">
            <DefaultButton
              text="소득공제 신고"
              clickEvent={() => {
                void clickEvt('income');
              }}
              status={downloading ? 'disable' : ''}
              icon="ri-download-2-line"
              type="type1"
              styleDef={{ height: '36px', fontSize: '13px', width: '200px', color: '#555' }}
            />
          </div>
          <div className="_item">
            <DefaultButton
              text="원천징수 영수증"
              clickEvent={() => {
                void clickEvt('withholding');
              }}
              status={downloading ? 'disable' : ''}
              icon="ri-download-2-line"
              type="type1"
              styleDef={{ height: '36px', fontSize: '13px', width: '200px', color: '#555' }}
            />
          </div>
          <div className="_item">
            <DefaultButton
              text="의료비 지급 영수증"
              clickEvent={() => {
                void clickEvt('medical');
              }}
              status={downloading ? 'disable' : ''}
              icon="ri-download-2-line"
              type="type1"
              styleDef={{ height: '36px', fontSize: '13px', width: '200px', color: '#555' }}
            />
          </div>
          <div className="_item">
            <DefaultButton
              text="기부금 명세서"
              clickEvent={() => {
                void clickEvt('donation');
              }}
              status={downloading ? 'disable' : ''}
              icon="ri-download-2-line"
              type="type1"
              styleDef={{ height: '36px', fontSize: '13px', width: '200px', color: '#555' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTaxData;
